<template>
  <div class="box">
    <iframe :src="url"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: "",
      shopData:{}
    };
  },
  mounted() {
    this.shopData = this.$shopData;
    this.url = process.env.VUE_APP_OrderProductQuery_ifrme+"?shopNum="+this.$shopData.shopNum;
  },
};
</script>
<style scoped>
.box,
iframe {
  width: 100%;
  height: calc(100vh - 145px);
  border: none;
}
</style>